import QuestionBase from '../base/question-base.js';

/**
 * @desc Placeholder for a dynamic question
 * @extends {QuestionBase}
 */
export default class DynamicQuestionPlaceholder extends QuestionBase {
    /**
     * Create instance.
     * @param {object} model - The instance of the model.
     */
    constructor(model) {
        super(model);
    }
}
